<div class="with-floating-button">
    <div class="content" *ngIf="iata">
        <page-header *ngIf="!isCreation" [title]="'admin.bibliotheque.geographie.iata.title' | translate: {libelle: (iata.type===TypeIata.AEROPORT && iata.codeIata) ? iata.codeIata :
        iata.codeGare ? iata.codeGare : ''}" [listeItems]="listeTabItems"
                     (onSelectedItemChange)="onSelectedItemChange($event)" (onGoBack)="onGoBack()">
        </page-header>

        <page-header *ngIf="isCreation" [title]="'admin.bibliotheque.geographie.iata.titleCreation' | translate" [listeItems]="listeTabItems"
                     (onSelectedItemChange)="onSelectedItemChange($event)" (onGoBack)="onGoBack()">
        </page-header>

        <div [hidden]="selectedItem?.code !== Onglets.GENERALITES">
            <form #form="ngForm" *ngIf="iata">
                <iata-generalites [iata]="iata"></iata-generalites>
            </form>
        </div>
        <floating-button [listeActions]="listeActions"></floating-button>
    </div>
    <please-wait class="content" *ngIf="!iata"></please-wait>
</div>